import {BaseApiResponseModel} from "../../../../infrastructure/models/base-api-response-model";
import type {PartialGameApiModel} from "../../../partial-game/models/partial-game-api-model";
import type {CountryApiModel} from "../../../common/country/models/country-api-model";
import type {SportApiModel} from "../../../sports/models/sport-api-model";
import type {CompetitionApiModel} from "../../../common/competition/models/competition-api-model";
import type {CompetitorApiModel} from "../../../common/competitor/models/competitor-api-model";
import type {PropositionBetsDetailsApiModel} from "./proposition-bets.details.api-model";
import {AthleteApiModel} from "../../../common/athlete/athlete-api-model";
import type {PropositionBetsApiModel} from "../../proposition/models/proposition-bets.api-model";
import type {BookmakerApiModel} from "../../../common/bookmaker/models/bookmaker-api-model";

export class PropositionBetsDetailsResponseApiModel extends BaseApiResponseModel {
  propsRecordsTable: PropositionBetsDetailsApiModel;
  propositionBets: Array<PropositionBetsApiModel>;
  sports: Array<SportApiModel>;
  countries: Array<CountryApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorApiModel>;
  athlete: AthleteApiModel;
  games: Array<PartialGameApiModel>;
  bookmakers: Array<BookmakerApiModel>;
  recordsText: String;

  constructor(model: PropositionBetsDetailsResponseApiModel) {
    super(model);

    this.propsRecordsTable = model?.propsRecordsTable;
    this.propositionBets = model?.propositionBets;
    this.sports = model?.sports;
    this.countries = model?.countries;
    this.competitions = model?.competitions;
    this.competitors = model?.competitors;
    this.athlete = model?.athlete;
    this.games = model?.games;
    this.bookmakers = model?.bookmakers;
    this.recordsText = model?.recordsText;
  }
}
